function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { Fragment } from 'react';
import { keyMap } from '@finect/front-utils/keyMap';
import { H5 } from '@finect/tabular-core/Headings';
import { X } from '@finect/tabular-icons/x';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, matchPath } from 'react-router-dom';
import { isBrowser } from '@finect/front-utils/isBrowser';
import { Datalayer } from '@finect/front-gtm';
import { setHelpState, setHelpActiveArticle, addHelpArticles } from './store/actions';
import { OverBkg, HelpBlock, HeaderBlock, BodyBlock, CloseModal } from './partials';
import { ArticleList, OpenAction, VideoList } from './components';
import { HelpArticle } from './HelpArticle';
var matchArticle = function matchArticle(article, currentPath, type) {
  var paths = typeof article.path === 'string' ? [article.path] : article.path;
  var matches = paths.map(function (path) {
    return [type].includes(article.type) && matchPath(currentPath, {
      path: path,
      exact: true,
      strict: false
    });
  });
  return matches.filter(function (item) {
    return item;
  }).length > 0;
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    state: state.help.state,
    articles: state.help.articles,
    activeArticle: state.help.activeArticle
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      setHelpState: setHelpState,
      setHelpActiveArticle: setHelpActiveArticle,
      addHelpArticles: addHelpArticles
    }, dispatch)
  };
};
export var Help = function (_React$Component) {
  _inherits(Help, _React$Component);
  var _super = _createSuper(Help);
  function Help() {
    var _this;
    _classCallCheck(this, Help);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "node", React.createRef());
    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.props.actions.setHelpState('closed');
    });
    _defineProperty(_assertThisInitialized(_this), "handleOpen", function () {
      _this.props.actions.setHelpState('opened');
    });
    _defineProperty(_assertThisInitialized(_this), "handleArticleAction", function (article) {
      _this.props.actions.setHelpActiveArticle(article.id);
    });
    _defineProperty(_assertThisInitialized(_this), "handleGoHome", function () {
      _this.props.actions.setHelpActiveArticle(null);
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (element) {
      if (!_this.node.contains(element.target)) {
        _this.handleClose();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeydown", function (event) {
      if (event.keyCode === keyMap.ESCAPE) {
        _this.handleClose();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "attachEvents", function () {
      document.addEventListener('keydown', _this.handleKeydown, false);
      document.addEventListener('mousedown', _this.handleClick, false);
    });
    _defineProperty(_assertThisInitialized(_this), "detachEvents", function () {
      document.removeEventListener('keydown', _this.handleKeydown, false);
      document.removeEventListener('mousedown', _this.handleClick, false);
    });
    return _this;
  }
  _createClass(Help, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.actions.addHelpArticles(this.props.initialArticles);
      if (['opened'].includes(this.props.state)) {
        this.attachEvents();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!['opened'].includes(this.props.state)) {
        this.detachEvents(this.target);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (['opened'].includes(prevProps.state) && ['opened'].includes(this.props.state)) return;
      ['opened'].includes(this.props.state) && this.attachEvents();
      !['opened'].includes(this.props.state) && this.detachEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        articles = _this$props.articles,
        activeArticle = _this$props.activeArticle,
        location = _this$props.location;
      var pathname = location.pathname;
      var viewWidth = isBrowser() ? window.innerWidth : 0;
      if (viewWidth < 768) {
        return null;
      }
      var routeArticles = articles.filter(function (article) {
        return matchArticle(article, pathname, 'article');
      });
      var routeVideos = articles.filter(function (article) {
        return matchArticle(article, pathname, 'video');
      });
      var totalItems = routeArticles.length + routeVideos.length;
      if (!(totalItems > 0)) {
        return null;
      }
      if (!['opened'].includes(this.props.state)) {
        return React.createElement(Fragment, null, React.createElement(OpenAction, {
          onAction: this.handleOpen
        }));
      }
      var currentArticle = articles.find(function (_ref) {
        var id = _ref.id;
        return id === activeArticle;
      });
      return React.createElement(Fragment, null, React.createElement(OverBkg, null), React.createElement(Datalayer, {
        id: "Impression",
        type: "fiEvent",
        params: {
          category: 'Interaction',
          action: 'help-main-impression',
          label: pathname
        }
      }), React.createElement(HelpBlock, {
        ref: function ref(node) {
          return _this2.node = node;
        }
      }, currentArticle ? React.createElement(HelpArticle, {
        article: currentArticle,
        onClose: this.handleClose,
        onBack: this.handleGoHome
      }) : null, !currentArticle ? React.createElement(Fragment, null, React.createElement(HeaderBlock, null, React.createElement(H5, null, "Inicio r\xE1pido"), React.createElement(CloseModal, {
        onClick: this.handleClose
      }, React.createElement(X, null))), React.createElement(BodyBlock, null, routeVideos.length ? React.createElement(VideoList, {
        videos: routeVideos
      }) : null, routeArticles.length ? React.createElement(ArticleList, {
        articles: routeArticles,
        onAction: this.handleArticleAction
      }) : null)) : null));
    }
  }]);
  return Help;
}(React.Component);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Help));